<template>
<div v-if="isVisible">
  <div class="modal__overlay">
    <div class="modal__wrapper">
      <div class="modal__body">
        <button class="modal__close-btn" @click="close()" aria-label="Select to close modal">
          <CloseButton />
        </button>
        <div class="modal__content">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script setup>
import {
  ref,
  watch,
  defineProps,
  defineEmits,
} from 'vue';
import CloseButton from '@/components/svg/CloseButton.vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const isVisible = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newValue) => {
    isVisible.value = newValue;
    if (isVisible.value) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },
);

const close = () => {
  emit('update:modelValue', false);
  // console.log('Fechou!');
};
</script>

<style lang="scss" scoped>
.modal {
  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background-color: rgb(3 6 27 / 50%);
    -webkit-backdrop-filter: blur(2px);
    backdrop-filter: blur(2px);
    padding: 75px 20px 100px;

    @media (min-width: 641px) {
      padding-top: 100px;
    }

    @media (min-width: 1281px) {
      padding-top: 170px;
    }
  }

  &__wrapper {
    max-width: 1642px;
    margin: 0 auto;
    background: $AC_White;
    border: 2px solid $AC_Black;
  }

  &__body {
    position: relative;
  }

  &__close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 25px;
    height: 25px;
    padding: 2px;
    border: 2px solid $AC_Orange;
    border-radius: 2px;
    color: $AC_Black;
    background-color: $AC_White;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;

    @media (min-width: 1025px) {
      top: 20px;
      right: 20px;
      width: 35px;
      height: 35px;
      border-width: 3px;
      padding: 5px;
    }

    @media (min-width: 1281px) {
      width: 50px;
      height: 50px;
      border-width: 5px;
    }

    &:hover,
    &:focus {
      background-color: $AC_Orange;
    }

    svg {
      height: auto;
    }
  }

  &__content {
    padding: 26px 14px 14px;

    @media (min-width: 641px) {
      padding: 30px;
    }

    @media (min-width: 1025px) {
      padding: 100px 80px;
    }
  }
}
</style>
